export const ROLES = {
  TEXTBOX: 'textbox',
  BUTTON: 'button',
  ALERT: 'alert',
  PRESENTATION: 'presentation',
  IMAGE: 'img',
  CHECKBOX: 'checkbox',
  COMBOBOX: 'combobox',
  OPTION: 'option',
  RADIO: 'radio',
  RADIOGROUP: 'radiogroup',
  SPINBUTON: 'spinbutton',
  PARAGRAPH: 'paragraph',
  MENU: 'menu',
}

export const V1_SITE_ID = '123456'

export const DEFAULT_V2_SITE_ID = '62421d2522dd166adc6b6ef3'
